export const PUBLICATION_REPAIR_MIN_WORDS = 2000;
export const PUBLICATION_REPAIR_MIN_RATIO = 0.95;
export const PUBLICATION_REPAIR_MAX_GROWTH_RATIO = 1.2;

export type PublicationRepairDecision =
  | { accepted: true; growthRatio: number }
  | {
      accepted: false;
      growthRatio: number;
      reason: 'below_minimum' | 'below_ratio' | 'excessive_growth';
      inputWords: number;
      outputWords: number;
    };

export function countWords(text: string): number {
  return (text || '').split(/\s+/).filter(Boolean).length;
}

export function evaluatePublicationRepairAcceptance(
  inputWords: number,
  outputWords: number,
): PublicationRepairDecision {
  const growthRatio = inputWords > 0 ? outputWords / inputWords : 0;

  if (outputWords < PUBLICATION_REPAIR_MIN_WORDS) {
    return {
      accepted: false,
      growthRatio,
      reason: 'below_minimum',
      inputWords,
      outputWords,
    };
  }

  if (outputWords < inputWords * PUBLICATION_REPAIR_MIN_RATIO) {
    return {
      accepted: false,
      growthRatio,
      reason: 'below_ratio',
      inputWords,
      outputWords,
    };
  }

  if (outputWords > inputWords * PUBLICATION_REPAIR_MAX_GROWTH_RATIO) {
    return {
      accepted: false,
      growthRatio,
      reason: 'excessive_growth',
      inputWords,
      outputWords,
    };
  }

  return { accepted: true, growthRatio };
}

export function logPublicationRepairGrowthRejected(payload: {
  inputWords: number;
  outputWords: number;
  growthRatio: number;
}): void {
  const growthPct = ((payload.growthRatio - 1) * 100).toFixed(1);
  console.log(
    `[PUBLICATION REPAIR GROWTH REJECTED] ${JSON.stringify({
      inputWords: payload.inputWords,
      outputWords: payload.outputWords,
      growthPercentage: `${growthPct}%`,
    })}`,
  );
}
